import React from 'react';
import { CoherencePanel, CoherencePanelSize } from '@coherence-design-system/controls';
import { useForm, FieldValues } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import { CoherencePanelStyles } from '../../../app/common/styles/CommonStyleObjects';
import ActionButtons from '../../common/ActionButtons';
import LoadingErrorMessage from '../../common/errorContent/LoadingErrorMessage';
import { UPDATE_LEGAL_IN_PROCESS_DETAILS } from '../../../utils/statApi/EntityTerminationApi';
import { GetCompanyByCompanyCode } from '../../../utils/statApi/CompaniesApi';
import LegalInProcessDetailsEditForm from './LegalInProcessDetailsEditForm';
import { ILegalInProcessDetails } from '../types';

interface ILegalInProcessDetailsEditPanelProps {
  closePanel: () => void;
  companyCode: string;
  details?: ILegalInProcessDetails;
}

const LegalInProcessDetailsEditPanel = (
  props: ILegalInProcessDetailsEditPanelProps,
): JSX.Element => {
  const { closePanel, companyCode, details } = props;
  const legalInProcessDetailsForm = useForm<FieldValues>({
    defaultValues: {
      ...details,
    },
  });
  const { handleSubmit } = legalInProcessDetailsForm;

  const [updateLegalInProcessDetails, { loading, error }] = useMutation(
    UPDATE_LEGAL_IN_PROCESS_DETAILS,
    {
      onCompleted: closePanel,
      refetchQueries: [
        {
          query: GetCompanyByCompanyCode,
          variables: { companyCode },
        },
      ],
    },
  );

  const handleSaveClick = (formData: ILegalInProcessDetails): void => {
    updateLegalInProcessDetails({
      variables: {
        companyCode,
        input: {
          accountingPlanLink: formData.accountingPlanLink,
        },
      },
    });
  };

  return (
    <CoherencePanel
      panelSize={CoherencePanelSize.medium}
      titleText="Edit Details"
      isOpen
      onDismiss={closePanel}
      styles={CoherencePanelStyles}
      hasCloseButton
      closeButtonAriaLabel="Close Details Edit Panel"
      onRenderFooter={(): JSX.Element => (
        <ActionButtons
          mutationLoading={loading}
          closePanel={closePanel}
          saveLabel="Save Details"
          saveTitle="Save Details"
          cancelLabel="Cancel"
          cancelTitle="Cancel"
          handleSubmit={handleSubmit(handleSaveClick)}
        />
      )}
    >
      <form>
        <LoadingErrorMessage error={error} loading={loading} />
        <LegalInProcessDetailsEditForm form={legalInProcessDetailsForm} details={details} />
      </form>
    </CoherencePanel>
  );
};

export default LegalInProcessDetailsEditPanel;
